import AppInputField from "components/shared/FormComponents/AppInputField";
import { AppRadioField } from "components/shared/FormComponents/AppRadioField";
import { useField } from "formik";
import { formatString } from "helpers/common";

const QuestionLocation = ({ question, fieldName }) => {
  const [field] = useField(fieldName);
  const options = question?.question_radio_tag;
  const inputLabels = question?.question_dd_labels;

  return (
    <>
      <div className="radio-inputs">
        <AppRadioField
          containerClass={"d-flex align-items-center py-1"}
          options={options.map(option => ({value: option, label: formatString(option)}))}
          name={`${fieldName}.other_details.radio_tag`}
          labelStyles={{
            color: "#071E3E",
            fontSize: "12px",
            fontWeight: "500",
            fontFamily: "Proxima Nova regular",
          }}
        />
      </div>
      {field?.value?.other_details?.radio_tag === "Virtual" && inputLabels?.length > 0 && (
        <div className="text-inputs py-2">
          {inputLabels.map((label, index) => (
            <div className="d-flex align-items-center gap-10 pb-3">
              <label
                key={index}
                style={{ width: "140px", textAlign:"right" }}
              >
                {formatString(label, false)}
              </label>
              <div style={{ width: "100%" }}>
                <AppInputField
                  name={`${fieldName}.other_details.dd_labels.${label}`}
                  placeholder="Enter Location"
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  )
}

export default QuestionLocation;